import * as React from "react";
import { motion } from "framer-motion";
import AchievmentConfig from "../AchievmentConfig";
import ReactParallaxTilt from "react-parallax-tilt";

const Achievements = () => {
  return (
    <div className="flex flex-col min-w-[280px] select-none h-[85vh] sx:h-max overflow-y-scroll transition-all duration-300  rounded-xl p-4 px-6 flex-grow">
      <div className="font-bold font-poppins text-2xl sx:text-xl">Achievements</div>
      <div className="flex flex-wrap my-4 justify-center gap-5">
        {AchievmentConfig.map((ele, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: index * 0.1 }}
            className="p-4 flex border bg-stone-600 bg-opacity-80 shadow rounded-lg flex-col justify-center items-center"
          >
            <ReactParallaxTilt tiltMaxAngleX={12} tiltMaxAngleY={10} className="w-40 mb-2">
              <img src={ele.image} alt={ele.badge} className="w-full" />
            </ReactParallaxTilt>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: index * 0.1 + 0.5 }}
              className="font-bold font-poppins"
            >
              {ele.rating}
            </motion.div>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: index * 0.1 + 0.5 }}
              className="font-poppins"
            >
              {ele.badge}
            </motion.div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Achievements;
